import { encrypt } from "./crypto";

export const setLocalStorage = async (token, refreshToken, user) => {
  console.log("user?.role :", user);
  const userrole = encrypt(user?.user_role);
  const is_influencer = encrypt(user?.is_influencer);
  console.log("userrole :", userrole);
  localStorage.setItem("authToken", token);
  localStorage.setItem("refreshToken", refreshToken);
  localStorage.setItem("name", user?.name);
  localStorage.setItem("email", user?.email);
  localStorage.setItem("phone", user?.phone_number);
  localStorage.setItem("7653", userrole); //7653 is set for user role here
  localStorage.setItem("profile_pic", user?.profile_url);
  localStorage.setItem("345234", is_influencer); //345234 is set for is infleuncer here
};
